import { savePIIAuditLog } from "../services/sharedServices";

// ASTT-7304: PII Access Logging.
// Called once per successful, non-empty PII disclosure on a report screen.
// oracleIds may be a single Oracle ID or a comma-separated list (a roster/RITM/
// facilities ticket can resolve to many trainees in one screen view).
const piiAuditLog = ({
  oracleIds,
  userGroup,
  sourceModule,
  moduleReference,
  piiFieldsShown,
  piiFieldsMasked,
}) => {
  if (!oracleIds) return;

  savePIIAuditLog({
    oracleIds,
    piiRequestBy: localStorage.getItem("User"),
    piiRequestByEmail: localStorage.getItem("EmailId"),
    userGroup,
    sourceModule,
    moduleReference,
    piiFieldsShown,
    piiFieldsMasked,
  });
};

export default piiAuditLog;
